<template>
  <header class="header" ref="header" @click.stop="close">
    <nav :class="['header-nav', { active: showNavList }]" @click.stop>
      <div class="header-inner">
        <div class="desktop-nav">
          <div class="nav-group">
            <div ref="productsTrigger" class="nav-item products-item">
              <button class="nav-link nav-button" @click.prevent="toggleProductsMenu">
                <span>{{ productsItem.title }}</span>
                <span :class="['caret', { open: showProductsDropdown }]">
                  <img :src="getImageUrl('nav/chevron-down.svg')" alt="" aria-hidden="true" />
                </span>
              </button>
              <div
                v-if="showProductsDropdown"
                ref="productsMenu"
                :class="['products-menu', { 'locale-ja': isJaLocale }]"
              >
                <div class="products-menu-content">
                  <div class="menu-col ifs-col">
                    <router-link
                      :to="toLocalizedRoute(pr.productsMenu.ifs.link)"
                      :class="['menu-title', { 'menu-title-ja': isJaLocale }]"
                      @click="hideProductsMenu"
                    >
                      {{ pr.productsMenu.ifs.title }}
                    </router-link>
                    <p class="menu-desc">{{ pr.productsMenu.ifs.desc }}</p>
                    <div class="ifs-links">
                      <component
                        v-for="child in pr.productsMenu.ifs.children"
                        :key="child.link"
                        :is="'a'"
                        target="_blank"
                        :href="child.link"
                        @click="hideProductsMenu"
                      >
                        <span>{{ child.title }}</span>
                        <img
                          :src="getImageUrl('external_link_icon.svg')"
                          alt=""
                          aria-hidden="true"
                        />
                      </component>
                    </div>
                  </div>
                  <div class="menu-col si-col">
                    <router-link
                      :to="toLocalizedRoute(pr.productsMenu.si.link)"
                      :class="['menu-title', { 'menu-title-ja': isJaLocale }]"
                      @click="hideProductsMenu"
                    >
                      {{ pr.productsMenu.si.title }}
                    </router-link>
                    <p class="menu-desc">{{ pr.productsMenu.si.desc }}</p>
                    <div class="si-links">
                      <router-link
                        v-for="child in pr.productsMenu.si.children"
                        :key="child.link"
                        :to="toLocalizedRoute(child.link)"
                        @click="hideProductsMenu"
                      >
                        <span>{{ child.title }}</span>
                      </router-link>
                    </div>
                  </div>
                  <div class="menu-col">
                    <div>
                      <router-link
                        :to="toLocalizedRoute(pr.productsMenu.rb.link)"
                        :class="['menu-title', { 'menu-title-ja': isJaLocale }]"
                        @click="hideProductsMenu"
                      >
                        {{ pr.productsMenu.rb.title }}
                      </router-link>
                      <p class="menu-desc">{{ pr.productsMenu.rb.desc }}</p>
                    </div>
                    <div :class="['uiux-menu', { hidden: isJaLocale }]">
                      <router-link
                        :to="toLocalizedRoute(pr.productsMenu.uiux.link)"
                        :class="['menu-title', { 'menu-title-ja': isJaLocale }]"
                        @click="hideProductsMenu"
                      >
                        {{ pr.productsMenu.uiux.title }}
                      </router-link>
                      <p class="menu-desc">{{ pr.productsMenu.uiux.desc }}</p>
                    </div>
                  </div>
                  <div :class="['menu-col', { hidden: !isJaLocale }]">
                    <router-link
                      :to="toLocalizedRoute(pr.productsMenu.uiux.link)"
                      :class="['menu-title', { 'menu-title-ja': isJaLocale }]"
                      @click="hideProductsMenu"
                    >
                      {{ pr.productsMenu.uiux.title }}
                    </router-link>
                    <p class="menu-desc">{{ pr.productsMenu.uiux.desc }}</p>
                  </div>
                </div>
              </div>
            </div>
            <button class="nav-link" @click.prevent="goTo(casesItem.link)">
              {{ casesItem.title }}
            </button>
          </div>

          <router-link
            :to="{ name: 'home', params: { lang: $route.params.lang } }"
            :class="['header-logo-link', { hidden: !shouldShowLogo }]"
          >
            <img :src="require('@/assets/fenrir_logo.svg')" class="header-logo-img" alt="Fenrir" />
          </router-link>

          <div class="nav-group">
            <button
              v-for="item in rightNavItems"
              :key="item.id"
              class="nav-link"
              @click.prevent="goTo(item.link)"
            >
              {{ item.title }}
            </button>
          </div>
        </div>

        <router-link
          :to="{ name: 'home', params: { lang: $route.params.lang } }"
          class="mobile-logo-link"
        >
          <img :src="require('@/assets/fenrir_logo.svg')" class="mobile-logo-img" alt="Fenrir" />
        </router-link>

        <button class="mobile-menu-btn" @click.prevent="toggle" aria-label="Toggle menu">
          <img
            v-if="!showNavList"
            class="mobile-menu-icon"
            :src="getImageUrl('nav/menu.svg')"
            alt=""
            aria-hidden="true"
          />
          <img
            v-else
            class="mobile-menu-icon"
            :src="getImageUrl('nav/close.svg')"
            alt=""
            aria-hidden="true"
          />
        </button>
      </div>

      <div :class="['mobile-panel', { active: showNavList }]">
        <div class="mobile-list-wrap">
          <div class="mobile-group">
            <p :class="['mobile-title', { 'mobile-title-ja': isJaLocale }]">{{ productsItem.title }}</p>
            <div class="mobile-sub-list" style="margin-top: 0;">
              <router-link
                :to="toLocalizedRoute(pr.productsMenu.ifs.link)"
                :class="['mobile-nav-link', { 'mobile-nav-link-ja': isJaLocale }]"
                @click="close"
              >
                {{ pr.productsMenu.ifs.title }}
              </router-link>
              <component
                v-for="child in pr.productsMenu.ifs.children"
                :key="`m-${child.link}`"
                :is="'a'"
                target="_blank"
                class="mobile-ifs-child-link"
                :href="child.link"
                @@click="close"
              >
                <span>{{ child.title }}</span>
                <img :src="getImageUrl('external_link_icon.svg')" alt="" aria-hidden="true" />
              </component>
            </div>
            <div class="mobile-sub-list">
              <router-link
                :to="toLocalizedRoute(pr.productsMenu.si.link)"
                :class="['mobile-nav-link', { 'mobile-nav-link-ja': isJaLocale }]"
                @click="close"
              >
                {{ pr.productsMenu.si.title }}
              </router-link>
              <router-link
                v-for="child in pr.productsMenu.si.children"
                :key="`m-${child.link}`"
                :to="toLocalizedRoute(child.link)"
                @click="close"
              >
                {{ child.title }}
              </router-link>
            </div>
            <div class="mobile-sub-list">
              <router-link
                :to="toLocalizedRoute(pr.productsMenu.rb.link)"
                :class="['mobile-nav-link', { 'mobile-nav-link-ja': isJaLocale }]"
                @click="close"
              >
                {{ pr.productsMenu.rb.title }}
              </router-link>
            </div>
            <div class="mobile-sub-list">
              <router-link
                :to="toLocalizedRoute(pr.productsMenu.uiux.link)"
                :class="['mobile-nav-link', { 'mobile-nav-link-ja': isJaLocale }]"
                @click="close"
              >
                {{ pr.productsMenu.uiux.title }}
              </router-link>
            </div>
          </div>
          <button :class="['mobile-link', { 'mobile-link-ja': isJaLocale }]" @click.prevent="goTo(casesItem.link)">
            {{ casesItem.title }}
          </button>
          <button
            v-for="item in rightNavItems"
            :key="`m-${item.id}`"
            :class="['mobile-link', { 'mobile-link-ja': isJaLocale }]"
            @click.prevent="goTo(item.link)"
          >
            {{ item.title }}
          </button>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import useRenderData from '@/composables/useRenderData';

// source: design/src/components/Header.tsx (export 2026-04-24)
export default {
  name: 'navigation',
  emits: ['toggle'],
  setup() {
    const { pr, getImageUrl } = useRenderData('nav');
    return {
      pr,
      getImageUrl,
    };
  },
  data() {
    return {
      showNavList: false,
      showProductsDropdown: false,
      userInteractionEnabled: true,
      menuCloseDuration: 300,
      shouldShowLogo: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick, true);
    window.addEventListener('scroll', this.updateLogoWithOffsetY, { passive: true });
    window.addEventListener('resize', this.syncMenuWithViewport, { passive: true });
    this.updateLogoWithPath(this.$route.name);
    this.updateLogoWithOffsetY();
    this.syncMenuWithViewport();
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleDocumentClick, true);
    window.removeEventListener('scroll', this.updateLogoWithOffsetY);
    window.removeEventListener('resize', this.syncMenuWithViewport);
  },
  computed: {
    isJaLocale() {
      return this.$route.params.lang === 'ja';
    },
    productsItem() {
      return this.pr.navList.find((item) => item.id === 'products') || {};
    },
    casesItem() {
      const item = this.pr.navList.find((entry) => entry.id === 'work-cards') || {};
      return {
        ...item,
        link: '/work-cards',
      };
    },
    rightNavItems() {
      return this.pr.navList.filter((item) => ['home-about', 'recruit'].includes(item.id));
    },
  },
  watch: {
    showNavList(val) {
      const vm = this;
      const active = 'active';
      const { classList } = vm.$refs.header;
      if (val && !classList.contains(active)) {
        classList.add(active);
        vm.$emit('toggle', true);
      } else {
        vm.userInteractionEnabled = false;
        vm.$emit('toggle', false);
        setTimeout(() => {
          classList.remove(active);
          vm.userInteractionEnabled = true;
        }, vm.menuCloseDuration);
      }
    },
    $route(to) {
      const { targetId } = to.params;
      this.updateLogoWithPath(to.name);
      this.close();
      if (targetId) {
        setTimeout(() => {
          this.scrollTo(targetId, 0);
        }, 0);
      }
      setTimeout(() => {
        this.updateLogoWithOffsetY();
      }, 0);
    },
  },
  methods: {
    toggle() {
      if (!this.userInteractionEnabled) return;
      this.showNavList = !this.showNavList;
    },
    close() {
      if (!this.userInteractionEnabled) return;
      this.showNavList = false;
      this.showProductsDropdown = false;
    },
    hideProductsMenu() {
      this.showProductsDropdown = false;
    },
    toggleProductsMenu() {
      this.showProductsDropdown = !this.showProductsDropdown;
    },
    updateLogoWithPath(name) {
      if (name !== 'home') {
        this.shouldShowLogo = true;
        return;
      }
      this.shouldShowLogo = false;
    },
    updateLogoWithOffsetY() {
      if (this.$route.name !== 'home') {
        this.shouldShowLogo = true;
        return;
      }
      const $homeLogo = $('#home-logo');
      if (!$homeLogo.length) {
        this.shouldShowLogo = false;
        return;
      }
      const hT = $homeLogo.offset().top;
      const hH = $homeLogo.outerHeight();
      const sT = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.shouldShowLogo = sT > hT + hH;
    },
    syncMenuWithViewport() {
      if (window.innerWidth > 768 && this.showNavList) {
        this.forceCloseMenu();
      }
    },
    forceCloseMenu() {
      this.showNavList = false;
      this.showProductsDropdown = false;
      const active = 'active';
      const { classList } = this.$refs.header || {};
      if (classList && classList.contains(active)) {
        classList.remove(active);
      }
      this.$emit('toggle', false);
      this.userInteractionEnabled = true;
    },
    handleDocumentClick(event) {
      if (!this.showProductsDropdown) return;
      const trigger = this.$refs.productsTrigger;
      const menu = this.$refs.productsMenu;
      const clickedInTrigger = trigger && trigger.contains(event.target);
      const clickedInMenu = menu && menu.contains(event.target);
      if (!clickedInTrigger && !clickedInMenu) {
        this.showProductsDropdown = false;
      }
    },
    toLocalizedRoute(path) {
      const { lang } = this.$route.params;
      return lang ? `/${lang}${path}` : path;
    },
    goTo(link) {
      this.hideProductsMenu();
      this.close();

      if (link.startsWith('/si')) {
        this.$router.push(this.toLocalizedRoute(link));
        return;
      }

      const targetId = link.replace('/', '#');
      const { name, params } = this.$route;
      if (name === 'home') {
        this.scrollTo(targetId);
      } else {
        this.$router.push({ name: 'home', params: { ...params, targetId } });
      }
    },
    scrollTo(targetId, animate = 1000) {
      let $target = null;
      if (targetId.startsWith('#about_')) {
        if ($('#about-info-sp').is(':visible')) {
          $target = $(`#about-info-sp > ${targetId}`);
        } else {
          $target = $('#about-info-pc');
          this.$bus.$emit('show-about-info', targetId.split('_')[1]);
        }
      } else {
        $target = $(targetId);
      }

      const $body = $('body');
      if ($target.length) {
        $body.addClass('disabled');
        $('html, body')
          .delay(this.menuCloseDuration)
          .stop()
          .animate(
            {
              scrollTop: $target.offset().top - 56,
            },
            animate,
            () => $body.removeClass('disabled'),
          );
      }
    },
  },
};
</script>

<style scoped lang="scss">
$navHeight: 64px;

.header {
  z-index: 1000;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  height: $navHeight;
  -webkit-tap-highlight-color: transparent;

  &.active {
    height: 100%;
    touch-action: none;
  }

  &-nav {
    width: 100%;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid #e4e9eb;
  }
}

.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  height: $navHeight;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.desktop-nav {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;

  @media screen and (max-width: 768px) {
    display: none;
  }
}

.nav-group {
  display: flex;
  align-items: center;
  gap: 0;
}

.nav-item {
  position: relative;
}

.nav-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 151px;
  height: $navHeight;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: #212121;
  font-size: 14px;
  line-height: 20px;
  padding: 0;
  transition: color 200ms ease;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background: #212121;
    opacity: 0;
    transition: opacity 200ms ease;
  }

  &:hover {
    opacity: 1;

    &::after {
      opacity: 1;
    }
  }
}

.nav-button {
  display: flex;
  align-items: center;
  gap: 4px;
}

.caret {
  width: 14px;
  height: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 200ms ease;

  img {
    width: 14px;
    height: 14px;
    display: block;
  }

  &.open {
    transform: rotate(180deg);
  }
}

.header-logo-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: $navHeight;
  overflow: hidden;
  transition: width 300ms cubic-bezier(0.165, 0.84, 0.44, 1),
    opacity 250ms cubic-bezier(0.165, 0.84, 0.44, 1);

  &:hover {
    opacity: 1;
  }

  &.hidden {
    width: 0;
    opacity: 0;
    pointer-events: none;
  }

  @media screen and (max-width: 768px) {
    width: auto;
    height: auto;
  }
}

.header-logo-img {
  width: 80px;
  height: 56px;
  padding: 12px 24px;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: auto;
    height: 28px;
    padding: 0;
  }
}

.products-menu {
  position: absolute;
  top: calc(100% - 16px);
  left: 0;
  width: 810px;
  background: #ffffff;
  border: 1px solid #e4e9eb;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
}

.products-menu-content {
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
}

.uiux-menu {
  margin-top: 24px;
}

.hidden {
  display: none;
}

.menu-title {
  margin: 0;
  display: inline-block;
  color: #212121;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  text-decoration: none;
}

.menu-title-ja {
  white-space: nowrap;
  word-break: keep-all;
}

.products-menu.locale-ja {
  .products-menu-content {
    grid-template-columns: 1fr 1fr;
  }

  .menu-title {
    white-space: nowrap;
    word-break: keep-all;
  }
}

.menu-title:hover {
  opacity: 1;
  color: #1565c0;
}

.menu-desc {
  margin: 8px 0 0;
  color: #74787a;
  font-size: 12px;
  line-height: 18px;
  transition: color 200ms ease;
  font-weight: bold;
}

.menu-title:hover + .menu-desc {
  color: #1565c0;
}

.ifs-links,
.si-links {
  margin-top: 20px;
  padding-left: 8px;
  border-left: 1px solid #e4e9eb;
  display: grid;
  gap: 10px;

  a {
    color: #666666;
    text-decoration: none;
    font-size: 14px;
    line-height: 18px;
    transition: color 200ms ease;

    &:hover {
      opacity: 1;
      color: #1565c0;

      img {
        filter: invert(31%) sepia(85%) saturate(2000%) hue-rotate(200deg);
      }
    }
  }

  span {
    font-weight: 500;
  }
}

.ifs-links {
  a {
    display: flex;
    align-items: center;
  }

  img {
    margin-left: 4px;
  }
}

.mobile-logo-link,
.mobile-menu-btn,
.mobile-panel {
  display: none;
}

@media screen and (max-width: 1024px) and (min-width: 769px) {
  .products-menu {
    position: fixed;
    top: 48px;
    left: 24px;
    right: 24px;
    width: auto;
    max-width: none;
  }

    .products-menu-content {
      gap: 16px;
    }

  .products-menu.locale-ja {
    .products-menu-content {
      gap: 10px;
    }

    .menu-title {
      font-size: 15px;
    }
  }
}

@media screen and (max-width: 768px) {
  .header {
    height: 56px;
  }

  .header-nav {
    border-bottom: 1px solid #e4e9eb;

    &.active {
      border-bottom: 0;
    }
  }

  .header-inner {
    height: 56px;
    justify-content: space-between;
    padding: 0 24px;
  }

  .mobile-logo-link {
    display: inline-flex;
    align-items: center;

    &:hover {
      opacity: 1;
    }
  }

  .mobile-logo-img {
    height: 28px;
    width: auto;
  }

  .mobile-menu-btn {
    display: inline-flex;
    width: 24px;
    height: 24px;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    border: 0;
    background: transparent;
    padding: 0;
    cursor: pointer;
  }

  .mobile-menu-icon {
    width: 24px;
    height: 24px;
    display: block;
  }

  .mobile-panel {
    display: block;
    border-top: 1px solid #e4e9eb;
    background: #ffffff;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    max-height: 0;
    overflow-y: auto;
    transition: max-height 300ms ease;

    &.active {
      max-height: 560px;
    }
  }

  .mobile-list-wrap {
    padding: 24px;
    display: grid;
    gap: 16px;
  }

  .mobile-group {
    margin-bottom: 0;
  }

  .mobile-title {
    margin: 0;
    color: #212121;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    padding: 8px 0;

    &.mobile-title-ja {
      font-weight: 600;
    }
  }

  .mobile-sub-list {
    margin-top: 20px;
    padding-left: 16px;
    border-left: 2px solid #e4e9eb;
    display: grid;
    gap: 8px;

    .mobile-nav-link {
      color: #212121;
      font-weight: 500;

      &.mobile-nav-link-ja {
        font-weight: 600;
      }
    }

    .mobile-ifs-child-link {
      display: flex;
      align-items: center;

      img {
        margin-left: 4px;
      }
    }

    a {
      color: #666666;
      text-decoration: none;
      font-size: 14px;
      line-height: 20px;
      padding: 4px 0;
    }
  }

  .mobile-link {
    width: 100%;
    text-align: left;
    border: 0;
    background: transparent;
    color: #212121;
    font-size: 16px;
    line-height: 24px;
    padding: 8px 0;
    cursor: pointer;
    font-weight: 500;

    &.mobile-link-ja {
      font-weight: 600;
    }
  }
}
</style>
